import Marquee from 'react-fast-marquee';
import { 
  FaGoogle, 
  FaMicrosoft, 
  FaAirbnb, 
  FaSpotify, 
  FaSlack, 
  FaHubspot,
  FaSalesforce,
  FaAmazon,
  FaLinkedin
} from 'react-icons/fa';
import { SiNotion, SiAsana, SiZoom } from 'react-icons/si';

const TrustSection = () => {
  const logos = [
    { Icon: FaGoogle, name: 'Google' },
    { Icon: FaMicrosoft, name: 'Microsoft' },
    { Icon: FaAirbnb, name: 'Airbnb' },
    { Icon: FaSpotify, name: 'Spotify' },
    { Icon: FaSlack, name: 'Slack' },
    { Icon: FaHubspot, name: 'HubSpot' },
    { Icon: FaSalesforce, name: 'Salesforce' },
    { Icon: FaAmazon, name: 'Amazon' },
    { Icon: SiNotion, name: 'Notion' },
    { Icon: SiAsana, name: 'Asana' },
    { Icon: SiZoom, name: 'Zoom' },
    { Icon: FaLinkedin, name: 'LinkedIn' },
  ];

  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="py-16 md:py-20 bg-[#F3EFEB] border-y border-[#0A192F]/10"
    >
      <div className="container-main mb-10">
        <p className="text-center text-[#4A5568] body-text" data-testid="trust-headline">
          Trusted by professionals and organizations seeking sustainable growth, 
          stronger leadership, and healthier work environments.
        </p>
      </div>

      <Marquee
        gradient={true}
        gradientColor="#F3EFEB"
        gradientWidth={100}
        speed={30}
        pauseOnHover={true}
      >
        {logos.map(({ Icon, name }, index) => (
          <div
            key={index}
            className="marquee-item flex items-center gap-2 text-[#4A5568]"
            data-testid={`trust-logo-${name.toLowerCase()}`}
          >
            <Icon size={32} />
            <span className="text-sm font-medium hidden sm:inline">{name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default TrustSection;
